module.exports = __webpack_public_path__ + "img/I-33.e14dd00a.svg";